import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { CalsoftNavigationItem } from '../../../navigation.types';
import { CalsoftVerticalNavigationComponent } from '../../vertical.component';
import { CalsoftNavigationService } from '../../../navigation.service';
import { ConfigService } from 'src/app/services/config.service';
import { CommonService } from 'src/app/services/common.service';
import { Route, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'calsoft-vertical-navigation-basic-item',
  templateUrl: './basic.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalsoftVerticalNavigationBasicItemComponent implements OnInit, OnDestroy {

  url = '';

  // Item
  @Input()
  item: CalsoftNavigationItem;

  // Name
  @Input()
  name: string;

  // Private
  private _calsoftVerticalNavigationComponent: CalsoftVerticalNavigationComponent;
  private _unsubscribeAll: Subject<any>;
  data: Object;
  headerBgColor: any = 1;

  /**
   * Constructor
   *
   * @param {CalsoftNavigationService} _calsoftNavigationService
   * @param {ChangeDetectorRef} _changeDetectorRef
   */
  constructor(
    private _calsoftNavigationService: CalsoftNavigationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private configService: ConfigService,
    private commonService: CommonService,
    private router: Router
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {


    let headerBgColor = localStorage.getItem('adminBreadcrumbType');

    if (headerBgColor != undefined) {
      this.headerBgColor = headerBgColor;
    }

    // Get the parent navigation component
    this._calsoftVerticalNavigationComponent = this._calsoftNavigationService.getComponent(this.name);

    // Subscribe to onRefreshed on the navigation component
    this._calsoftVerticalNavigationComponent.onRefreshed.pipe(
      takeUntil(this._unsubscribeAll)
    ).subscribe(() => {

      // Mark for check
      this._changeDetectorRef.markForCheck();
    });
  }


  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
      this._onDestroy.next();
      this._onDestroy.complete();
  }

  generateLetterIcon(name) {

    const words = name.split(' ');

    if (words.length > 1) {
      return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toLowerCase();
    } else {
      return name.charAt(0).toUpperCase() + name.charAt(1).toLowerCase();
    }
  }

  // clearStorage(link) {


  //   if (window.innerWidth <= 768) {
  //     this.toggleNavigation('mainNavigation')

  //   }
  //   // this.vertical.closeAside();

  //   this.commonService.clearStorage(link);

  //   // this.navigateToRoute(link)

  // }

  toggleNavigation(key): void {
    // Get the navigation
    const navigation = this._calsoftNavigationService.getComponent(key);

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }

  navigateToRoute(link: string) {
    this.router.navigate([link]).then(() => {
      console.log('Navigation successful');
    });
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  onItemClick(): void {
    if (this._calsoftVerticalNavigationComponent && this._calsoftVerticalNavigationComponent.activeAsideItemId) {
      this._calsoftVerticalNavigationComponent.closeAside();
    }
  }

    protected _onDestroy = new Subject<void>();
}
